'use es6';

import getSettings from 'self-service-api/api/getSettings';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchSettingsRequestTypes = createRequestTypes('SETTINGS');
export const FetchSettingsActions = createRequestActions(FetchSettingsRequestTypes);
export const fetchSettings = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchSettingsActions,
    fetch: getSettings
  })(dispatch);
};